export default function reportPackageSummaryDirective() {
  return {
    template: require('./report-package-summary.html'),
    controller: 'PRReportPackageSummaryController',
    controllerAs: 'prReportPackageSummaryVM',
    bindToController: true,
    replace: true,
    scope: {
      customerId: '@',
      reportPackage: '=',
    },
  };
}
